    <template>
  <a-card :bordered="false">
    <a-button type="primary" v-has:rebalancingCreate="()=> {$router.push('/antiFleeingGoods/documents/rebalancing/create?type=add')}">
      <PlusOutlined />
     创建调仓单
    </a-button>
    <a-form class="m-b-20 m-t-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="transfer_warehousing_sn">调仓单号</a-select-option>
            <a-select-option value="create_role_name">创建人</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <!-- <a-form-item label="调入仓库" name='transfer_to_warehouse_id'>
        <a-select v-model:value="search.transfer_to_warehouse_id" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item> -->
          <a-form-item label="调出仓库" name='transfer_to_warehouse_id'>
        <a-select v-model:value="search.transfer_to_warehouse_id" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
           <a-form-item label="调仓单状态" name='transfer_status'>
        <a-select v-model:value="search.transfer_status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">待调仓</a-select-option>
          <a-select-option value="2">调仓完成</a-select-option>
          <a-select-option value="3">订单关闭</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='warehousing_sn' :columns='columns' :data-source='list' class="tableFixBox" :scroll="{ x: 'max-content'}">
      <template v-slot:product_name="{ record }">
        <div v-if='record.product.length == 1' >
          <div v-for="(item,index) in record.product" :key='index'>
            <a-card-meta>
              <template #description>{{!item.product_sku_name || item.product_sku_name=='0' ? '单规格':item.product_sku_name}} - {{item.product_name}}</template>
            </a-card-meta>
          </div>
        </div>
        <div class="s_flex_ali" v-else>
          <p class="m-l-5 m-r-10">多商品</p>
          <a-button type="primary" size="small" @click='targetList=record.product;goodDetailVisible=true'>查看商品详情</a-button>
        </div>
      </template>
       <template v-slot:to="{ record }">
        <p>{{record.transfer_to_warehouse_name}}</p>
        {{record.transfer_to_warehouse_position_id_name}}
      </template>
      <template v-slot:real_num="{record}">
          <p @click="codeDetailVisible=true;targetId=record.transfer_warehousing_sn" style="color:#f04635;cursor: pointer;">
            {{record.product.map(v=>v.transfer_warehousing_real_num).reduce(function(p,c){return p+c})}}</p>
      </template>
      <template v-slot:action="{ record }">
        <a-button v-has:storehouseDetail="()=> {$router.push('/antiFleeingGoods/storehouseDetail?id='+record.transfer_warehousing_sn)}" class="m-r-10">查看详情</a-button>
        <a-button v-has:rebalancingDel='()=>del(record.id)' class="m-r-10" danger>删除</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
  </a-card>
  <!-- 二维码详情 -->
   <a-modal title='调仓二维码明细' :keyboard="false" v-model:visible="codeDetailVisible" centered  :width='1300' destroyOnClose :footer='null'>
       <codeDetail :id="targetId"/>
   </a-modal>
   
  <a-modal title='调仓单详情' :keyboard="false" :maskClosable='false' v-model:visible="orderDetailVisible" destroyOnClose :footer='null' :width="800" centered>
    <warehousingDetails  :id="targetId" />
  </a-modal>
    <a-modal title='商品详情' :keyboard="false" :maskClosable='false' v-model:visible="goodDetailVisible" destroyOnClose :footer='null' :width="1200" centered>
    <goodDetail  :listdata="targetList"/>
  </a-modal>
</template>
<script>
  import { PlusOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import store from '@/store'
  import { getWarehouseList,transferWarehousing,transferWarehousingClose } from '@/api/antiFleeing';
  import config from '@/config'
  import codeDetail from './components/codeDetail'
  import warehousingDetails from '../../components/warehousingDetails.vue'
  import goodDetail from '../../components/goodDetails.vue'
  // 初始化默认筛选项数值

  export default {
    components: {PlusOutlined,codeDetail,warehousingDetails,goodDetail},
    setup() {
      const state = reactive({
        goodDetailVisible:false,
        targetList:[],
        time: [],
        warehouseList:[],
        orderDetailVisible:false
      });
      let columns = [
        {
          title: "调仓单号",
          dataIndex: "transfer_warehousing_sn",
          key: "transfer_warehousing_sn",
        },
        {
          title: "调仓仓库",
          dataIndex: "transfer_to_warehouse_position_id_name",
          key: "transfer_to_warehouse_position_id_name",
          slots: { customRender: "to" },
        },
        {
          title: "商品信息",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
          width:300
        },
      {
        title: "调仓数量",
        dataIndex: "num",
        key: "num",
        customRender:function({record}){
          return  record.product.length? record.product.map(v=>v.transfer_warehousing_num).reduce(function(p,c){return p+c}):''
        }
      },
        {
          title: "实际数量",
          dataIndex: "real_code_num",
          key: "real_code_num",
          slots: {customRender: "real_num" }
        },
           {
          title: "类型",
          dataIndex: "create_type_text",
          key: "create_type_text"
        },
               {
          title: "状态",
          dataIndex: "transfer_status_text",
          key: "transfer_status_text"
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "操作",
          key: "action",
          fixed:"right",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: {
      start_time: "",
      end_time: "",
      transfer_status:"",
      page: 1,
      limit: 10,
      keyword:"",
      transfer_to_warehouse_id:'',
      key_type: "transfer_warehousing_sn",
      create_type:'2',
      show_zero:1
    } });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      // 关闭
      const del = (id) => {
        $Modal.confirm({
          centered: true,
          title:'是否删除调仓单？',
          onOk: async () => {
            let res = await transferWarehousingClose(id).then((res) => res.data);
            if (iscode(res, true)) {
              tableHoosks.initData(transferWarehousing, search.value);
            }
          },
        });
      };
      // 二维码详情
      const codeDetailVisible=ref(false)
      const targetId=ref(false)
      onMounted(() => {
        getWarehouse()
        tableHoosks.initData(transferWarehousing, search.value);
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime,
        del,
        info: store.state.user.info,
        codeDetailVisible,
        targetId
      };
    },
  };
</script>